'use client';

import { TooltipProvider, SSOProvider } from '@blendviewer/ui';
import { ReactNode } from 'react';

export function Providers({ children }: { children: ReactNode }) {
  return (
    <SSOProvider
      config={{
        projectId: import.meta.env.VITE_PROJECT_ID || 'code-playground',
        apiUrl: import.meta.env.VITE_API_URL || 'https://cloud-api.blendviewer.com',
      }}
      onLoginSuccess={(user) => {
        console.log('[RunCode] User logged in:', user.name);
      }}
      onLogoutSuccess={() => {
        console.log('[RunCode] User logged out');
      }}
    >
      <TooltipProvider>{children}</TooltipProvider>
    </SSOProvider>
  );
}

